/**
 * @fileoverview Keep client-only chat error rows when thread history is reloaded from the server.
 */

import type { ChatMessage } from './types'

function isClientOnlyErrorMessage(message: ChatMessage): boolean {
  const meta = message.metadata as Record<string, unknown> | undefined
  if (meta?.error !== true) {
    return false
  }
  if (meta.fallback === true) {
    return true
  }
  return message.id.startsWith('error-')
}

/** Merge server history with local error messages that were never persisted. */
export function mergeThreadMessagesPreservingClientErrors(
  fromServer: ChatMessage[],
  previous: ChatMessage[],
): ChatMessage[] {
  const serverIds = new Set(fromServer.map((m) => m.id))
  const clientErrors = previous.filter(
    (m) => isClientOnlyErrorMessage(m) && !serverIds.has(m.id),
  )
  if (clientErrors.length === 0) {
    return fromServer
  }
  return [...fromServer, ...clientErrors].sort(
    (a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0),
  )
}
